import {Spinner} from "react-bootstrap";

const Preloader = (props) => {
    const {isReady, maskOnly} = props

    return (
        <div className={`preloader ${!isReady ? 'IsLoading' : ''} ${maskOnly ? 'mask' : ''}`}>
            {!maskOnly && <Spinner size="md" variant="primary" />}
        </div>
    )
}

export default Preloader